// 钻石卡类型枚举
export const diamondCardTypes = {
  consumables_card: {
    type: 1,
    key: 'consumables_card',
    name: '耗材卡',
  },
  wearable_card: {
    type: 2,
    key: 'wearable_card',
    name: '穿戴卡',
  },
  service_card: {
    type: 3,
    key: 'service_card',
    name: '服务卡',
  },
};

export const getDiamondCardType = (tags) => {
  let tag = null;
  tags.some((key) => {
    if (diamondCardTypes[key]) {
      tag = diamondCardTypes[key].key;
      return true;
    }
    return false;
  });
  return tag;
};
